export const Fats = {
    AGUACATE: {
        name: "Aguacate",
        netMacro: 10,
        totalWeight: 70
    },
    ACEITEOLIVA: {
        name: "Aceite de oliva",
        netMacro: 10,
        totalWeight: 10
    },
    FRUTOSSECOS: {
        name: "Frutos secos",
        netMacro: 10,
        totalWeight: 15
    },
    CREMASFRUTOSSECOS: {
        name: "Cremas de frutos secos",
        netMacro: 10,
        totalWeight: 15
    },
    SEMILLAS: {
        name: "Semillas",
        netMacro: 10,
        totalWeight: 20
    }
};
